import {Injectable, Inject} from 'ng-metadata/core';
import {AccountService} from '../../account/account.service';
import {PersonalInfoService} from '../../account/personalInfo/personalInfo.service';
import {FormBuilderEnums,FormBuilderService,IValidationMsg} from '../formBuilder/formBuilder.service';
import {DateUtils} from '../../nddUtils/dateUtils.service';

import { getInjectableName } from 'ng-metadata/core';

@Injectable()
export class DepositFormService {

    private _formFields = [];   //service form
    private _form = [];         //current form
    private _formData = {};     //form fields data
 	private _repeatableCounter = {};     //form fields repeatable limit
 
	private _uiTypes = {
		TextField: FormBuilderEnums.UI_TYPE.TEXT,
		Date: FormBuilderEnums.UI_TYPE.DATE,
		TextArea: FormBuilderEnums.UI_TYPE.TEXT_AREA,
		Hidden: FormBuilderEnums.UI_TYPE.HIDDEN,
		ComboBox: FormBuilderEnums.UI_TYPE.DROP_DOWN,
		ComboBoxMultipleNew: FormBuilderEnums.UI_TYPE.DROP_DOWN_MULTIPLE,
		Radio:FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
		CheckboxBoolean:FormBuilderEnums.UI_TYPE.CHECK_BOX
	};

    private _fieldType = {
        String  : 'string',
        Date    : 'date',
        ComboBoxMultipleNew: 'comboboxmultiplenew',
        Empty:'empty'
    };

    constructor(private accountService:AccountService,
				private formBuilderService:FormBuilderService,
				private dateUtils: DateUtils,
                @Inject('$translate') private $translate) {
    }

    public deleteFile(depositfiles, index){
        depositfiles.splice(index,1);
    }

	public commit(params){
		return this.accountService.makeIlsRequest('submit_deposit', params);
	}

	public validateForm(depositInfo, depositForm):IValidationMsg{

        let errorMessages = [];
        let isOk:boolean = true;

        if ((!depositInfo.title || depositInfo.title == "") && this._form.length == 0){
         	isOk= false;
		}

		if (this._form.length != 0){
			this._formFields.forEach((formField)=>{let form=depositForm;
			if (formField.uiType.endsWith('repeatable')&&formField.mandatory){
				if (this.isRepeatableEmpty(formField.name)){
					form[formField.name].$error.required=true;
					form[formField.name].$dirty=true; 
					isOk= false;
				} 
			}
				if (formField.uiType == 'checkbox' && form[formField.name].$viewValue == false && formField.mandatory){
					form[formField.name].$error.required=true;
					// form-field-checkbox.html uses $touch to determine to display error or not
					form[formField.name].$touched=true;
					isOk= false;
				}
			if (form[formField.name] && form[formField.name].$error && form[formField.name].$error.required &&!formField.value ){ 
			form[formField.name].$dirty=true; 
			isOk= false; }});
		}
		
		let noOfFilesUploaded = 0;
		if (depositInfo.depositFiles && depositInfo.depositFiles.length) {
			noOfFilesUploaded = depositInfo.depositFiles.filter(file => file.isUploaded).length;
		}
        if (!depositInfo.saveAsDraft && (noOfFilesUploaded == 0)){
        	isOk= false;
         	errorMessages.push('nui.deposit.validation.mandatoryFiles');
		}

        return {isOk: isOk, errorMessages: errorMessages};

	}
	
	public isRepeatableEmpty(name){
		for (var index=0;index<7;index++){
			if (this._formData[name+index]!= undefined&&this._formData[name+index]!= ''){
				return false;
			}
		}
		return true;
	}
    /* getters / setters */
    get formFields() {
        return this._formFields;
    }

    set formFields(formFields) {
        this._formFields = formFields;
    }

    get form() {
        return this._form;
    }

    set form(form) {
        this._form = form;
    }

    get formData() {
        return this._formData;
    }

    set formData(formData) {
        this._formData = formData;
    }
    get repeatableCounter() {
        return this._repeatableCounter;
    }

    set repeatableCounter(repeatableCounter) {
        this._repeatableCounter = repeatableCounter;
    }
	
	public handleDynamicForm( formInfo , dcFields,editForm){

 		this._formFields = [];
 		this._formData = {};
 		this._form= [];

		if (formInfo != undefined){
			let formFields= [];
			let formFieldsArray = formInfo.formfields.formfield;

			formFieldsArray.forEach((formField)=>{let dcFields1=dcFields; formFields.push(this.parseField(formField, dcFields1,editForm))});

			this._formFields = formFields;
			this._form= formFields;
		}
	}

	private parseField (formField, dcFields,editForm){
		var fieldStyle ={};
		if (formField.uitype == 'Radio'){
		   fieldStyle= {layout: 'column'};
		   }
		   var fieldType= this._fieldType[formField.fieldtype];
		   var label = formField.label;
		if (formField.uitype == 'CheckboxBoolean'){
		   fieldType = FormBuilderEnums.FIELD_TYPE.STRING;
		   formField.options={option:[{value: formField.label, key: ''}]};
		  label='';
		   }
		let field={
			key: formField.key,
			name: formField.name,
			label: label,
			mandatory: formField.mandatory,
			uiType: this._uiTypes[formField.uitype],
			fieldType: fieldType,
			options: this.parseOptions(formField.options),
			value: formField.value,
			css: 'deposit-dialog-container',
			style: fieldStyle,
			tooltip: formField.tooltip,
			checkBoxValue:formField.checkboxvalue
		};
		//for repeatable loop{		this._formData[field.name+index]= formField.value;}
		if (formField.repeatable){
			field.uiType= this._uiTypes[formField.uitype]+'repeatable';
			this.repeatableCounter[field.name]=1;
			for (var index=0;index<7;index++){
				if (field.fieldType === FormBuilderEnums.FIELD_TYPE.DATE && field.mandatory){
			this._formData[field.name+index]= new Date();
			}else{
						this._formData[field.name+index]=formField.value;
			}
			if (dcFields[field.name+index] != undefined){
					this.repeatableCounter[field.name]=index+1;
					if (field.fieldType === FormBuilderEnums.FIELD_TYPE.DATE){
						this._formData[field.name+index]= this.dateUtils.convertPrimoDateStringToDateType(dcFields[field.name+index]);
					}else{
						this._formData[field.name+index]= dcFields[field.name+index];
					}
				}
			}

			return field;
		}
		this._formData[field.name]= formField.value;
		if (field.fieldType === FormBuilderEnums.FIELD_TYPE.DATE && field.mandatory){
			this._formData[field.name]= new Date();
		}
		if (dcFields[field.name] != undefined){
			if (field.fieldType === FormBuilderEnums.FIELD_TYPE.DATE){
				this._formData[field.name]= this.dateUtils.convertPrimoDateStringToDateType(dcFields[field.name]);
			}else if (field.uiType === FormBuilderEnums.UI_TYPE.DROP_DOWN_MULTIPLE){
					  this._formData[field.name]= dcFields[field.name].split('; ');		
			}
			else{
				this._formData[field.name]= dcFields[field.name];
			}
		}
		 if (field.uiType === FormBuilderEnums.UI_TYPE.CHECK_BOX){
		 if (dcFields[field.name] != undefined){
		  this._formData[field.name]='Yes';
		 }else if (editForm){
		 this._formData[field.name]='No';
		}
		}
		      if (field.uiType===FormBuilderEnums.UI_TYPE.DROP_DOWN&&field.mandatory){
        	field.$dirty=true; 
        }
		return field;
	}

	private parseOptions(options){
		let comboOptions= [];
		if (options != undefined && options.option != undefined){
			options.option.forEach((option)=>comboOptions.push({"label":option.value,"value":option.key}));
		}

		return comboOptions;
	}
	
	public isExceededMaxNoOfFiles(depositInfo) {
        if (depositInfo.depositFiles == undefined || depositInfo.depositFiles.length == 0) {
        	return false;
        } else {
        	for (var i = 0; i < depositInfo.depositFiles.length; i++) {
        		if (depositInfo.depositFiles[i].exceedNoOfFileLimit) {
        			return true;
        		}
        	}
    	}
    	return false;
    }
    
    public isExceededMaxFileSize(depositInfo) {
        if (depositInfo.depositFiles == undefined || depositInfo.depositFiles.length == 0) {
        	return false;
        } else {
        	for (var i = 0; i < depositInfo.depositFiles.length; i++) {
        		if (depositInfo.depositFiles[i].exceedFileSizeLimit) {
        			return true;
        		}
        	}
    	}
    	return false;
    }

    public isNotAllowedFileExtension(depositInfo) {
        if (depositInfo.depositFiles == undefined || depositInfo.depositFiles.length == 0) {
        	return false;
        } else {
        	for (var i = 0; i < depositInfo.depositFiles.length; i++) {
        		if (depositInfo.depositFiles[i].notAllowedFileExtension) {
        			return true;
        		}
        	}
    	}
    	return false;
    }

}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/deposit/depositForm.service.ts